/* @flow strict */

/* eslint-disable camelcase */

import _ from 'lodash';

// import available from '/client/src/checks/available';

// const sessionStorage = available<{ token?: string }>('sessionStorage', {});
// const localStorage = available<{ token?: string }>('localStorage', {});

export type HeadersType = {
  Authorization?: string
};

interface iCredentials {
  getHeaders: () => HeadersType,
  login: (string, ?boolean) => void,
  logout: () => void
}

const HTTPStatus = require('http-status');

class Credentials implements iCredentials {
  static getHeaders = (isWidget: boolean | null): HeadersType => {
    const _token = this.getToken(isWidget);

    return _token ? { Authorization: `token ${_token}` } : {};
  };

  static getToken = (isWidget: boolean | null): string | null => {
    const param = !isWidget ? 'user' : 'SPARXO_userSF';
    const tokenStr = _.get(window.sessionStorage, param, null) || _.get(window.localStorage, param, null);

    return  tokenStr ? JSON.parse(tokenStr).access_token : null;
  };

  static getUser = (isWidget: boolean | null): string | null => {
    const param = !isWidget ? 'user' : 'SPARXO_userSF';

    const userObj = _.get(window.sessionStorage, param, null) || _.get(window.localStorage, param, null);
    const _user = userObj ? JSON.parse(userObj) : null;

    return _user;
  };

  // eslint-disable-next-line
  static login = (token: string, user: {}, rememberMe: boolean = false, isWidget: boolean | null) => {
    const param1 = !isWidget ? 'user' : 'SPARXO_userSF';

    window.localStorage.setItem(param1, JSON.stringify(user));
  };

  static logout = (isNoNeedReboot: boolean, isWidget: boolean | null) => {
    const param1 = !isWidget ? 'user' : 'SPARXO_userSF';
    const param2 = !isWidget ? 'token' : 'SPARXO_tokenSF';

    window.localStorage.removeItem(param2);
    window.localStorage.removeItem(param1);

    if (!isNoNeedReboot) {
      window.location.reload();
    }
  };

  static logoutByExpOrError = (error: {}, isWidget: any) => {
    if (_.get(error, 'response.status', 500) === HTTPStatus.UNAUTHORIZED) {
      if (!isWidget) {
        this.logout(true);

        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
  }
}

export default Credentials;
